//Empty order history component for working later
import React from 'react'

function OrderHistory() {
  return (
    <div>OrderHistory</div>
  )
}

export default OrderHistory